module.exports = __webpack_public_path__ + "media/images/landkit/avatars/avatar-4-19d3787fd9017de6772cc4172392c3a2.jpg";